<template>
    <router-view />
</template>
<style lang="scss">
  @import "@/assets/style/public.scss";
</style>
